<template>
  <div>
    <v-form ref="form"
            v-model="valid"
    >
      <v-card style="padding: 20px">
        <v-card-title>Add Windows or Active Directory User</v-card-title>
        <v-card-text>
          <v-text-field
            v-model="newUser"
            autofocus
            label="Name"
            :rules="[rules.required]"
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <div class="row row--end">
            <v-btn text
                   @click="$emit('cancel')"
            >Cancel</v-btn>
            <v-btn
              text
              @click="setWindowsUsersInUserGroup(group, [...group.windowsUsers, newUser])"
              color="primary"
              :disabled="!valid"
            >Add user</v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import { HubConnection } from "@microsoft/signalr";
export default {
  name:  "AddUserToGroupForm",
  props: {
    connection: HubConnection,
    group:      Object,
  },
  data: function() {
    return {
      valid:   false,
      newUser: "",
      rules:   {
        required: (value) => !!value || "Required",
      },
    };
  },
  methods: {
    setWindowsUsersInUserGroupRequest(groupId, newUsers) {
      return this.connection.invoke(
        "SetWindowsUsersInUserGroup",
        groupId,
        newUsers
      );
    },
    setWindowsUsersInUserGroup(group, newUsers) {
      return this.setWindowsUsersInUserGroupRequest(group.id, newUsers)
        .then((response) => {
          if (response.resultKind === "Success") {
            this.$emit("groups-updated", response.entity);
            this.$emit("ok");
          } else {
            this.$emit("failure", response.reason);
          }
        })
        .catch((response) => {
          this.$emit("failure", response);
        });
    },
  },
};
</script>

<style scoped></style>
